<div *ngIf="!loading">
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="animated fadeIn">
  <div *ngIf="!modalMostraMapa">
    <div class="timeline-body">

      <h4>
        <span *ngIf="listCronogramaFisico.length != 0">
          Lista do Cronograma
          <button (click)="openModalAddEtapaCronogramaFisico(formAdicionarEtapaCronogramaFisico)"
            class="btn btn-success btn-xs  pull-right">
            <i class="fa fa-plus"></i> Add Etapa</button>
        </span>
        <button (click)="openModalAddCronogramaFisicoExecucaoObjeto(formAdicionarCronogramaFisicoExecucaoObjeto)"
          class="btn btn-success btn-xs  pull-right" style="margin-right: 10px;">
          <i class="fa fa-plus"></i> Add Meta</button>
      </h4>

      <div *ngIf="listCronogramaFisico.length == 0">
        <div class="timeline-footer">
          <a class="btn btn-primary btn-sm" (click)="openEtapa4()">Voltar</a>
        </div>
      </div>


      <div *ngFor="let meta of listCronogramaFisico; let iterationMeta = index;">
        <div class="box" *ngIf="listCronogramaFisico.length != 0">
          <div class="box-header">
            <br>
            <br>
            <h3 class="box-title">
              <b>Meta {{ iterationMeta+1 }}:</b> &nbsp; {{ meta.meta }}</h3>
            <p class="help-block">{{ meta.descricaoMeta }}</p>
            <div class="box-tools">

              <button (click)="confirmarExclusaoCronogramaFisicoExecucaoObjeto(meta)"
                class="btn btn-primary btn-xs  pull-right" style="margin: 3px;">
                <i class="fa fa-trash"></i> Excluir</button>&nbsp;&nbsp;

              <button (click)="openModalEditarCronogramaFisicoExecucaoObjeto(meta)"
                class="btn btn-primary btn-xs  pull-right" style="margin: 3px;">
                <i class="fa fa-edit"></i> Editar</button>&nbsp;&nbsp;

              <button (click)="openModalAddEtapaCronogramaFisico(formAdicionarEtapaCronogramaFisico, meta)"
                class="btn btn-primary btn-xs  pull-right" style="margin: 3px 0 0 0;">
                <i class="fa fa-plus"></i> Add Etapa</button>&nbsp;&nbsp;

              <!--
              <a [routerLink]="['mapa', meta.id]" *ngIf="meta.longitude" (click)="openModalvincularMetaAoMapa()"
                class="btn btn-primary btn-xs  pull-right" style="margin: 3px;">
                <i class="fa fa-map-o"></i> Vincular ao mapa</a>

              <a [routerLink]="['mapa', meta.id]" *ngIf="!meta.longitude" (click)="openModalvincularMetaAoMapa()"
                class="btn btn-danger btn-xs  pull-right" style="margin: 3px;">
                <i class="fa fa-map-o"></i> Vincular ao mapa</a>

            -->
            </div>
          </div>
          <div class="box-body table-responsive no-padding">



            
            <table class="table">
              <tbody>
                <tr>
                  <th>Especificação</th>
                  <th>Início</th>
                  <th>Término</th>
                  <th class="text-center" style="min-width: 95px;">Ações</th>
                </tr>
                <tr *ngFor="let etapa of meta.etapaCronogramaFisico; let iterationEtapa = index;">
                  <td>
                    <b>Etapa {{ iterationMeta+1 }}.{{ iterationEtapa+1 }}:</b> &nbsp; {{ etapa.especificacao
                  }}
                  </td>
                  <td>{{ etapa.dataIni | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ etapa.dataFim | date: 'dd/MM/yyyy' }}</td>
                  <td class="text-center">
                    
                    <!--
                    <a *ngIf="etapa.longitude" [routerLink]="['mapa/etapa', etapa.id]"
                      (click)="openModalvincularMetaAoMapa()" class="fa fa-map-o"
                      style="font-size: 20px; cursor:pointer; color: #2017a0c7;"></a>
                    <a *ngIf="!etapa.longitude" [routerLink]="['mapa/etapa', etapa.id]"
                      (click)="openModalvincularMetaAoMapa()" class="fa fa-map-o"
                      style="font-size: 20px; cursor:pointer; color: #ff3636ab;"></a>&nbsp;&nbsp;
                    -->
                    
                    <i (click)="openModalEditarEtapaCronogramaFisico(etapa, meta.id)" class="fa fa-edit"
                      data-toggle="tooltip" data-placement="right" title="Editar"
                      style="font-size: 20px; cursor:pointer; color: #2017a0c7;"></i>&nbsp;&nbsp;
                    <i (click)="confirmarExclusaoEtapaCronogramaFisico(etapa, meta)" class="fa fa-trash"
                      data-toggle="tooltip" data-placement="right" title="Excluir"
                      style="font-size: 20px; cursor:pointer; color: #ff3636ab;"></i>
                  </td>
                </tr>
              </tbody>
            </table>
            


          </div>
        </div>
      </div>


    </div>

    <div *ngIf="listCronogramaFisico.length != 0">
      <div class="timeline-footer">
        <a class="btn btn-primary btn-sm" (click)="openEtapa4()">Voltar</a>
        <a class="btn btn-primary btn-sm" (click)="openEtapa6()">Continuar</a>
      </div>
      <br>
      <br>
    </div>
  </div>

  <div *ngIf="modalMostraMapa">
    <a (click)="esconderMapa()" class="btn btn-primary btn-xs  pull-right" style="margin: 10px;">
      <i class="fa fa-undo"></i> Voltar</a>
    <router-outlet></router-outlet>
  </div>

</div>

<!-- MODAIS -->
<p-dialog [style]="{width: '600px'}" (onHide)="closeModalEditarCronogramaFisicoExecucaoObjeto()" header="Editar meta"
  [(visible)]="modalEditarCronogramaFisicoExecucaoObjeto" showEffect="fade" [modal]="true">
  <form #formAlterarCronogramaFisicoExecucaoObjeto="ngForm" autocomplete="off"
    (ngSubmit)="alterarCronogramaFisicoExecucaoObjeto()">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Meta</label>
        <input pInputText type="text" name="meta" [(ngModel)]="cronogramaFisicoExecucaoObjetoEditar.meta" required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>Descrição da meta</label>
        <input pInputText type="text" name="descricaoMeta"
          [(ngModel)]="cronogramaFisicoExecucaoObjetoEditar.descricaoMeta">
        <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
      </div>
      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar"
          [disabled]="formAlterarCronogramaFisicoExecucaoObjeto.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [style]="{width: '600px'}" header="Nova meta" [(visible)]="modalAdicionarCronogramaFisicoExecucaoObjeto"
  showEffect="fade" [modal]="true">
  <form #formAdicionarCronogramaFisicoExecucaoObjeto="ngForm" autocomplete="off"
    (ngSubmit)="adicionarCronogramaFisicoExecucaoObjeto()">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Meta</label>
        <input pInputText type="text" name="meta" [(ngModel)]="cronogramaFisicoExecucaoObjetoAdd.meta" required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>Descrição da meta</label>
        <input pInputText type="text" name="descricaoMeta"
          [(ngModel)]="cronogramaFisicoExecucaoObjetoAdd.descricaoMeta">
        <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
      </div>
      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar"
          [disabled]="formAdicionarCronogramaFisicoExecucaoObjeto.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [style]="{width: '600px'}" header="Nova etapa" [(visible)]="modalAdicionarEtapaCronogramaFisico" showEffect="fade"
  [modal]="true">
  <form #formAdicionarEtapaCronogramaFisico="ngForm" autocomplete="off" (ngSubmit)="adicionarEtapaCronogramaFisico()">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Meta</label>
        <p-select name="cronogramaFisicoExecucaoObjeto" [options]="listDropDownCronogramaFisicoExecucaoObjeto"
          placeholder="Selecione" [filter]="true"
          [(ngModel)]="etapaCronogramaFisicoAdd.cronogramaFisicoExecucaoObjeto.id" required></p-select>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Especificação</label>
        <input pInputText type="text" name="especificacao" [(ngModel)]="etapaCronogramaFisicoAdd.especificacao"
          required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>Descrição</label>
        <p class="help-block">Informar as ações a serem executadas e os indicadores que aferirão o cumprimento da etapa.
        </p>
        <textarea pInputTextarea rows="3" name="descricao" [(ngModel)]="etapaCronogramaFisicoAdd.descricao"></textarea>
      </div>

      <div class="col-md-6 ui-fluid">
        <label for="imput11">*Início:</label>
        <input [(ngModel)]="etapaCronogramaFisicoAdd.dataIni" name="dataIni" type="datetime-local" class="form-control"
          id="imput11" required>
      </div>
      <div class="col-md-6 ui-fluid">
        <label for="imput12">*Término:</label>
        <input [(ngModel)]="etapaCronogramaFisicoAdd.dataFim" name="dataFim" type="datetime-local" class="form-control"
          id="imput12" required>
        <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
      </div>

      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar" [disabled]="formAdicionarEtapaCronogramaFisico.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [style]="{width: '600px'}" (onHide)="closeModalEditarEtapaCronogramaFisico()" header="Editar etapa"
  [(visible)]="modalEditarEtapaCronogramaFisico" showEffect="fade" [modal]="true">
  <form #formAlterarEtapaCronogramaFisico="ngForm" autocomplete="off"
    (ngSubmit)="alterarEtapaCronogramaFisico()">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Meta</label>
        <p-select disabled name="cronogramaFisicoExecucaoObjeto" [options]="listDropDownCronogramaFisicoExecucaoObjeto"
          placeholder="Selecione" [filter]="true"
          [(ngModel)]="etapaCronogramaFisicoEditar.cronogramaFisicoExecucaoObjeto.id" required></p-select>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Especificação</label>
        <input pInputText type="text" name="especificacao" [(ngModel)]="etapaCronogramaFisicoEditar.especificacao"
          required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>Descrição</label>
        <textarea pInputTextarea rows="3" name="descricao"
          [(ngModel)]="etapaCronogramaFisicoEditar.descricao"></textarea>
      </div>
      <div class="col-md-6 ui-fluid">
        <label for="imput11">*Início:</label>
        <input [(ngModel)]="etapaCronogramaFisicoEditar.dataIni" name="dataIni" type="datetime-local"
          class="form-control" id="imput11" required>
      </div>
      <div class="col-md-6 ui-fluid">
        <label for="imput12">*Término:</label>
        <input [(ngModel)]="etapaCronogramaFisicoEditar.dataFim" name="dataFim" type="datetime-local"
          class="form-control" id="imput12" required>
        <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
      </div>
      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar" [disabled]="formAlterarEtapaCronogramaFisico.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>